module.exports = __webpack_public_path__ + "media/media/svg/callback-success-9a3b3bb10d43632cfa2ee0a90ac6a7f1.svg";